import * as React from 'react';

export const SvgIcon = ({ path, fill, width }: { path: string; fill: string, width?: any }) => (
  <svg viewBox="0 0 24 24" fill={fill} width={width || '1.5em'}>
    <path d={path} />
  </svg>
);

export default SvgIcon;
